import { render, staticRenderFns } from "./splitOrderPopover.vue?vue&type=template&id=583db2b9&scoped=true"
import script from "./splitOrderPopover.vue?vue&type=script&lang=js"
export * from "./splitOrderPopover.vue?vue&type=script&lang=js"
import style0 from "./splitOrderPopover.vue?vue&type=style&index=0&id=583db2b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583db2b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583db2b9')) {
      api.createRecord('583db2b9', component.options)
    } else {
      api.reload('583db2b9', component.options)
    }
    module.hot.accept("./splitOrderPopover.vue?vue&type=template&id=583db2b9&scoped=true", function () {
      api.rerender('583db2b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/components/splitOrderPopover.vue"
export default component.exports